// libraries
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import { createSelector } from 'reselect';
import { getTradeInsAmountOwed, getTradeInsValue } from './offerNodeSelectors';

export const getGlobalTradeIn = (state: OfferReduxBaseState) => {
    return state.tradeIn;
};

export const getTradeInCard = (state: OfferReduxBaseState) => {
    return state.tradeInCard;
};

export const getTradeIn = createSelector(getGlobalTradeIn, getTradeInCard, (globalTradeIn, scopedTradeIn) => ({
    ...globalTradeIn,
    ...scopedTradeIn
}));

export const getTradeNetValue = (state: OfferReduxBaseState): number => getTradeValue(state) - getTradeInAmountOwedFromOffer(state);

export const getTradeValue = (state: OfferReduxBaseState): number => {
    const fallbackValue = state.tradeIn?.value || 0;
    return getTradeInsValue(state, fallbackValue);
};

export const getTradeInAmountOwedFromOffer = (state: OfferReduxBaseState): number => {
    const fallbackValue = state.tradeIn?.amountOwed || 0;
    return getTradeInsAmountOwed(state, fallbackValue);
};

export const getTradeMake = (state: OfferReduxBaseState) => {
    return getTradeIn(state).make || '';
};

export const getTradeModel = (state: OfferReduxBaseState) => {
    return getTradeIn(state).model || '';
};

export const getTradeYear = (state: OfferReduxBaseState) => {
    const year = getTradeIn(state).year;
    return !year ? '' : year.toString();
};

export const getTradeTrim = (state: OfferReduxBaseState) => {
    return getTradeIn(state).trim || '';
};

export const getTradeSource = (state: OfferReduxBaseState) => {
    return getTradeIn(state).source ?? '';
};
